module.exports = __webpack_public_path__ + "img/qa.e4014edd.png";